import { render, staticRenderFns } from "./PatientsByDayOrWeek.vue?vue&type=template&id=687877a2"
import script from "./PatientsByDayOrWeek.vue?vue&type=script&lang=js"
export * from "./PatientsByDayOrWeek.vue?vue&type=script&lang=js"
import style0 from "./PatientsByDayOrWeek.vue?vue&type=style&index=0&id=687877a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports